import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Forgot from './pages/Forgot';
import ChangePassword from './pages/ChangePassword';
import OtpVerification from './pages/OtpVerification';
import DashboardApp from './pages/DashboardApp';
import Properties from './pages/Properties';
import AddProperties from './pages/AddProperties';
import Category from './pages/Category';
import Cities from './pages/Cities';
import UserInquiry from './pages/UserInquiry';
import Setting from './pages/Setting/Setting';
import MyAccount from './pages/MyAccount';
import Rolepermission from './pages/Rolepermission';
import AddProject from './pages/Projects/AddProject';
import ProjectList from './pages/Projects/ProjectList';
import UserManagement from './pages/UserManangement';
import SubProjectList from './pages/SubProjects/SubProjectList';
import UploadList from './pages/UploadList';
import About from './pages/About';
import Blog from './pages/Blog';
import ReviewRating from './pages/ReviewRating';
import FeaturesCategory from './pages/FeaturesCategory';
import FeaturesList from './pages/FeaturesList';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsCondition from './pages/TermsCondition';
import ContactUs from './pages/ContactUs';
import Faqs from './pages/Faqs';
import FaqsCategory from './pages/FaqsCategory';
import ContactTrash from './pages/ContactTrash';
import PropertyLeadManagement from './pages/PropertyLeadManagement';
import ValuationTool from './pages/ValuationTool';
import RecentActivities from './sections/dashboard-sections/RecentActivities';
import RecentActivitiesPage from './pages/RecentActivitiesPage';
import Checkout from './pages/Checkout';

export default function Router() {
  const localPerm = JSON.parse(localStorage.getItem('permissions'));
  const token = localStorage.getItem('token');
  const initialroute = localPerm?.[0].path || '/dashboard';

  return useRoutes([
    {
      path: '/',
      element: token ? <Navigate to={initialroute} /> : <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/login" /> },
        { path: 'login', element: <Login /> },
        { path: 'forgot', element: <Forgot /> },
        { path: 'change-password', element: <ChangePassword /> },
        { path: 'otp-verification', element: <OtpVerification /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        // dashboard
        {
          path: 'dashboard',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <DashboardApp />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'properties',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <Properties />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'add-properties',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <AddProperties />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'add-properties/:id',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <AddProperties />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'about-us',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <About />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'blogs',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <Blog />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'privacy-policy',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <PrivacyPolicy />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'terms-&-conditions',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <TermsCondition />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'review-rating',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <ReviewRating />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'categories',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <Category />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/cities',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <Cities />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/tour-request-inquiries',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <UserInquiry />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/settings',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <Setting />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/feature-category',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <FeaturesCategory />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/feature-list',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <FeaturesList />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/contact-us-inquiries',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <ContactUs />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/leads-management',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <PropertyLeadManagement />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/checkout',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <Checkout />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/valuation-tool',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <ValuationTool />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/recent-activities',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <RecentActivitiesPage />
          ) : (
            <Navigate to="/404" />
          )
        },

        {
          path: '/faqs-category',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <FaqsCategory />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: '/faqs',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'dashboard') ? (
            <Faqs />
          ) : (
            <Navigate to="/404" />
          )
        },

        // ROLE/PERMISSION
        {
          path: 'roles',
          element: localPerm?.some(
            (item) => item.permission_name.toLowerCase() === 'role/permissions'
          ) ? (
            <Rolepermission />
          ) : (
            <Navigate to="/404" />
          )
        },

        // ROLE/PERMISSION
        {
          path: 'user-management',
          element: localPerm?.some(
            (item) => item.permission_name.toLowerCase() === 'user management'
          ) ? (
            <UserManagement />
          ) : (
            <Navigate to="/404" />
          )
        },

        //PROJECTS
        {
          path: 'projects',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'projects') ? (
            <ProjectList />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'project/add',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'projects') ? (
            <AddProject />
          ) : (
            <Navigate to="/404" />
          )
        },
        {
          path: 'project/edit',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'projects') ? (
            <AddProject />
          ) : (
            <Navigate to="/404" />
          )
        },

        // SUB PROJECT
        {
          path: 'project/sub-projects',
          element: localPerm?.some((item) => item.permission_name.toLowerCase() === 'projects') ? (
            <SubProjectList />
          ) : (
            <Navigate to="/404" />
          )
        },

        // UPLOAD LIST
        {
          path: 'upload-list',
          element: localPerm?.some(
            (item) => item.permission_name.toLowerCase() === 'upload list'
          ) ? (
            <UploadList />
          ) : (
            <Navigate to="/404" />
          )
        },

        // MY-ACCOUNT
        {
          path: 'my-account',
          element: <MyAccount />
        },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
